import React, { useState, useMemo } from 'react';

import VideosTable from './custom-table';
import useClips from '../../../core/hooks/use-clips';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

import * as S from './styles';

function Clips() {
  const [isRefetching, setIsRefetching] = useState(false);

  const {
    data: {
      clips = [],
    },
    loading: isLoadingClips,
    refetch: refetchClips,
    fetchMore,
    hasMore,
  } = useClips();

  const isLoading = useMemo(() => isLoadingClips || isRefetching, [isLoadingClips, isRefetching]);

  const handleRefetch = async () => {
    // This is necessary because the refetch function does not update the loading state
    setIsRefetching(true);
    await refetchClips();
    setIsRefetching(false);
  };

  return (
    <S.Container>
      <S.Header>
        <S.Title>
          Clips
        </S.Title>
        <S.SubtitleWrapper>
          <S.Text>
            This list contains clips that were reprocessed five times and still have no audio track.
          </S.Text>

          <S.Button
            onClick={handleRefetch}
            disabled={isLoading}
          >
            Refresh list
          </S.Button>
        </S.SubtitleWrapper>
      </S.Header>

      {(isLoading) && (
        <S.LoaderContainer>
          <S.Loader data-loader="user-tracking-loader" />
        </S.LoaderContainer>
      )}

      {!isLoading && clips.length === 0 && (
        <S.LoaderContainer>
          <S.Text>
            No videos found.
          </S.Text>
        </S.LoaderContainer>
      )}

      {!isLoading && clips.length > 0 && (
        <VideosTable
          videosData={clips}
          fetchMore={fetchMore}
          hasMore={hasMore}
        />
      )}
    </S.Container>

  );
}

export default withDashboardSidebar(Clips);
